<script lang="ts">
  // Full-page block shown when the tenant is suspended. Rendered in an iframe so the
  // error-page CSS (Tailwind-like global class names) can't clash with the app's Tailwind.
  import template from './suspended-page/template.html?raw';
  import css from './suspended-page/main.css?raw';
  import type { SubscriptionInfo } from '$lib/stores/subscription.store';

  let { info }: { info: SubscriptionInfo } = $props();

  const esc = (v: string) =>
    v.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!);

  const fmtDate = (iso: string) =>
    new Date(iso).toLocaleDateString('id-ID', { dateStyle: 'long', timeZone: 'Asia/Makassar' });

  let srcdoc = $derived.by(() => {
    const manual = !!info.reason;
    const values: Record<string, string> = manual
      ? {
          ERROR_CODE: '503',
          TITLE: 'Server timeout',
          HOST_STATUS: 'Dinonaktifkan',
          WHAT_HAPPENED: `<p>Akses ke aplikasi ini sedang dinonaktifkan oleh penyedia layanan.</p><p>Keterangan: ${esc(info.reason!)}</p>`,
          WHAT_CAN_I_DO: '<p>Hubungi administrator perusahaan Anda atau penyedia layanan. Data Anda tetap aman dan tidak dihapus.</p><p>Muat ulang halaman ini setelah layanan diaktifkan kembali.</p>',
        }
      : {
          ERROR_CODE: '402',
          TITLE: 'Server host timeout',
          HOST_STATUS: 'Langganan berakhir',
          WHAT_HAPPENED: `<p>Masa langganan aplikasi ini telah berakhir${info.periodEnd ? ` pada ${esc(fmtDate(info.periodEnd))}` : ''} dan masa tenggang sudah lewat.</p>`,
          WHAT_CAN_I_DO: '<p>Hubungi administrator untuk memperpanjang langganan. Data Anda tetap aman dan tidak dihapus.</p><p>Muat ulang halaman ini setelah langganan diperpanjang.</p>',
        };

    const all: Record<string, string> = {
      ...values,
      TITLE: esc(values.TITLE),
      HOST_STATUS: esc(values.HOST_STATUS),
      HOST: esc(window.location.hostname),
      TIME: esc(`${new Date().toISOString().replace('T', ' ').slice(0, 19)} UTC`),
      RAY_ID: esc(info.rayId ?? '-'),
      CSS: css,
    };
    return template.replace(/{{(\w+)}}/g, (_, key: string) => all[key] ?? '');
  });
</script>

<svelte:head><title>{info.reason ? '503: Layanan dinonaktifkan' : '402: Langganan berakhir'}</title></svelte:head>

<iframe title="Layanan tidak tersedia" sandbox="" class="fixed inset-0 w-full h-full border-0 bg-white" {srcdoc}></iframe>
